import React from "react";
import { StudentActivity } from "components/pages/Educator/StudentActivity/StudentActivity";

export const AdminStudentActivity = ({ selectedEducator, sharedClassId, onClassChange }) => {
  if (!selectedEducator) return null;
  return (
    <StudentActivity
      key={selectedEducator.id}
      educatorId={selectedEducator.id}
      sharedClassId={sharedClassId}
      onClassChange={onClassChange}
    />
  );
};
